module.exports = __webpack_public_path__ + "static/media/asahi-mizuno-lose.70708038.jpg";